var map = {
	"./decidim/avatar-multiuser.png": 965,
	"./decidim/brands/google.svg": 84851,
	"./decidim/cc-badge.png": 44556,
	"./decidim/decidim-logo.svg": 49221,
	"./decidim/default-avatar.svg": 74040,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 60334,
	"./decidim/icons.svg": 68039,
	"./decidim/pattern.png": 2664,
	"./decidim/placeholder.jpg": 5948,
	"./decidim/vendor/leaflet/layers-2x.png": 15442,
	"./decidim/vendor/leaflet/layers.png": 86319,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 62348,
	"./decidim/vendor/leaflet/marker-icon.png": 6529,
	"./decidim/vendor/leaflet/marker-shadow.png": 20140,
	"./decidim/vendor/social-share-button/delicious.svg": 45736,
	"./decidim/vendor/social-share-button/douban.svg": 12689,
	"./decidim/vendor/social-share-button/email.svg": 68703,
	"./decidim/vendor/social-share-button/facebook.svg": 2326,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 15687,
	"./decidim/vendor/social-share-button/google_plus.svg": 81957,
	"./decidim/vendor/social-share-button/hacker_news.svg": 18281,
	"./decidim/vendor/social-share-button/linkedin.svg": 71835,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 80766,
	"./decidim/vendor/social-share-button/pinterest.svg": 45222,
	"./decidim/vendor/social-share-button/qq.svg": 42812,
	"./decidim/vendor/social-share-button/reddit.svg": 21,
	"./decidim/vendor/social-share-button/telegram.svg": 20365,
	"./decidim/vendor/social-share-button/tumblr.svg": 60747,
	"./decidim/vendor/social-share-button/twitter.svg": 39003,
	"./decidim/vendor/social-share-button/vkontakte.svg": 70862,
	"./decidim/vendor/social-share-button/wechat.svg": 70715,
	"./decidim/vendor/social-share-button/weibo.svg": 56014,
	"./decidim/vendor/social-share-button/whatsapp.svg": 55742,
	"./decidim/vendor/social-share-button/xing.svg": 48469
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28982;